// @ts-nocheck
import styled from 'styled-components';

export const DownloadSubHeaderStyled = styled.div`
  background: linear-gradient(243.22deg, #202939 0%, #222C3D 100%);
  padding: 1.5rem;
  color: ${props => props.theme.white};
  letter-spacing: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 50px;

  @media (min-width: 900px) {
    padding: 1.5rem 13.25rem;
  }

  .reportingSubHeader {
    &__title {
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeL};
      line-height: ${props => props.theme.fontSizeXL};
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }
  }

  .item {
    display: flex;
    gap: 0.25rem;
    aling-items: center;
    font-size: ${props => props.theme.fontSizeXS};
    line-height: ${props => props.theme.fontSizeM};
  }

  .item--name {
    font-family: ${props => props.theme.fontLight};
  }

  item--value {
    font-family: ${props => props.theme.fontSemiBold};
  }
`;
